import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "forwardedAs"];
import React from 'react';
import { useMenuContext } from './Menu';
import Button from 'components/Button';
function MenuButton(_ref) {
  var as = _ref.as,
    forwardedAs = _ref.forwardedAs,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useMenuContext = useMenuContext(),
    menuButtonProps = _useMenuContext.menuButtonProps;
  var Component = as || Button;
  var optionalProps = {};
  if (forwardedAs) {
    optionalProps.as = forwardedAs;
  }
  return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, optionalProps, menuButtonProps));
}
export default MenuButton;